import { Card, Modal } from "antd";
import { cleanCanvas } from "../../utils/functions/drawFunctions.js";
import { formatToPost } from "../../utils/functions/postFunctions.js";

const CameraModal = ({
  showModalConfirm,
  setShowModalConfirm,
  camerasToEdit,
  indexListCameras,
  setCurrentCamera,
  listCameras,
  setIndexListCameras,
  setCameras,
  drawMode,
  zones,
  lines,
  setZones,
  setLines,
  setTableData,
  setColorIndex,
  setCurrentColor,
  canvas,
  cameras,
  currentCamera,
  VIBRANT_COLORS,
  currentImageUrl,
  isEndEdition,
  isLastCamera,
  setEndEdition,
  configId,
  setPostCameras,
  setShowModal,
  setIsEndEdition,
}) => {
  const showNextCamera = () => {
    if (camerasToEdit.length === 0) return;

    const nextIndex = (indexListCameras + 1) % camerasToEdit.length;

    setCurrentCamera(listCameras[nextIndex]);
    setIndexListCameras(nextIndex);

    setCameras({
      ...cameras,
      [currentCamera.id]: drawMode === "zone" ? zones : lines,
    });

    // Resetar estados para a próxima câmera
    setZones([]);
    setLines([]);
    setTableData([]);
    setColorIndex(0);
    setCurrentColor(VIBRANT_COLORS[0].code);
    cleanCanvas(canvas.getContext("2d"), canvas);
  };

  const endEdition = () => {
    setCameras({
      ...cameras,
      [currentCamera.id]: drawMode === "zone" ? zones : lines,
    });

    if (isLastCamera) {
      setEndEdition(true);
      formatToPost(
        {
          ...cameras,
          [currentCamera.id]: drawMode === "zone" ? zones : lines,
        },
        drawMode,
        configId,
        setPostCameras,
        listCameras
      );
    } else {
      setShowModal(true);
    }
  };

  return (
    <Modal
      type="confirm"
      title="Confirme as mudanças!"
      width="fit-content"
      okText="Confirmar"
      cancelText="Cancelar"
      onOk={() => {
        setShowModalConfirm(false);
        if (isEndEdition) {
          endEdition();
          setIsEndEdition(false);
        } else showNextCamera();
      }}
      onCancel={() => setShowModalConfirm(false)}
      open={showModalConfirm}
      align="center">
      <Card align="center">
        <img src={currentImageUrl} alt="confirm creations" />
      </Card>
    </Modal>
  );
};

export default CameraModal;
